import { render, staticRenderFns } from "./HeroFull.vue?vue&type=template&id=c0081e24&scoped=true&"
import script from "./HeroFull.vue?vue&type=script&lang=js&"
export * from "./HeroFull.vue?vue&type=script&lang=js&"
import style0 from "./HeroFull.vue?vue&type=style&index=0&id=c0081e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0081e24",
  null
  
)

export default component.exports